import React from 'react';

import { PageReactDataTable } from '@metarouter-private/mr-mui';

import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import UserModalContextProvider from '../context/UserModalContextProvider';
import UserConfirmDeleteContextProvider from '../context/UserConfirmDeleteContextProvider';
import { useOrganizationMembersTable } from '../hooks/use-organization-members-table';

import buildColumns from './buildColumns';
import { UserManagementTableTitle } from './UserManagementTableTitle';
import TableAction from './table-action/TableAction';

const PER_PAGE = 5;

export const UserManagementTable = () => {
  const invitationsTable = useOrganizationMembersTable();
  const { eventDebuggerEcmEnabled } = useFeatureEnabled(FEATURE_FLAGS.eventDebuggerEcm);

  const columns = buildColumns(eventDebuggerEcmEnabled);

  return (
    <UserModalContextProvider>
      <UserConfirmDeleteContextProvider>
        <PageReactDataTable
          title={<UserManagementTableTitle />}
          columns={columns}
          actions={<TableAction />}
          perPage={PER_PAGE}
          {...invitationsTable}
        />
      </UserConfirmDeleteContextProvider>
    </UserModalContextProvider>
  );
};
